import React from 'react';
import { useSiteMetadata } from '../../hooks';

export default function SEO({
	title,
	subtitle,
	image,
	description,
	pathname,
	children,
}) {
	// https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component/
	const {
		title: defaultTitle,
		description: defaultDescription,
		image: defaultImage,
		siteUrl,
	} = useSiteMetadata();

	// Determine the title based on what props are passed
	let computedTitle = defaultTitle;
	if (title && subtitle) {
		// Blog post case: 'title | subtitle'
		computedTitle = `${title} | ${subtitle}`;
	} else if (title) {
		// Regular page case: 'title | defaultTitle'
		computedTitle = `${title} | ${defaultTitle}`;
	}

	const seo = {
		title: computedTitle,
		description: description
			? description + ' | ' + defaultDescription
			: defaultDescription,
		image: `${siteUrl}${image || defaultImage}`,
		url: `${siteUrl}${pathname || ``}`,
	};

	return (
		<>
			<html lang="en" />
			<title>{seo.title}</title>
			<meta name="description" content={seo.description} />
			<meta name="image" content={seo.image} />
			{children}
		</>
	);
}
